<template>
    <span :class="['pill', `pill--${variant}`]">
        <v-icon
            v-if="icon"
            :color="iconColor"
            size="14"
        >
            {{ icon }}
        </v-icon>
        <slot>{{ label }}</slot>
    </span>
</template>

<script>
export default {
    name: 'StatBadge',
    props: {
        variant: {
            type: String,
            default: 'neutral',
            validator: v => ['positive', 'primary', 'neutral', 'error'].includes(v),
        },
        icon: {
            type: String,
            default: null,
        },
        label: {
            type: [String, Number],
            default: '',
        },
    },
    computed: {
        iconColor() {
            switch (this.variant) {
                case 'positive': return 'success'
                case 'primary': return 'primary'
                case 'error': return 'error'
                default: return 'on-surface-variant'
            }
        },
    },
}
</script>
